import { useCallback, useState } from 'react'
import { useSearchParams } from 'react-router-dom'

import { LocalFilters } from '../types'

export const useFiltrosPrêmios = () => {
  const [searchBarParams, setSearchParams] = useSearchParams()
  const [currentPage, setCurrentPage] = useState(1)

  // Estado local para os filtros do drawer (não aplicados até clicar em "Aplicar Filtros")
  const [localFilters, setLocalFilters] = useState<LocalFilters>({
    categoria: '',
    valorMinimo: '',
    valorMaximo: '',
    rankingGeral: false,
    rankingCidade: false,
    rankingEscola: false,
    rankingTurma: false,
    naoVinculado: false,
    posicaoMinima: '',
    posicaoMaxima: '',
    orderBy: 'nome',
    orderDirection: 'asc',
  })

  // Função para atualizar filtros locais
  const updateLocalFilter = useCallback(
    (key: keyof LocalFilters, value: any) => {
      setLocalFilters((prev) => ({ ...prev, [key]: value }))
    },
    [],
  )

  // Função para aplicar todos os filtros
  const applyFilters = useCallback(() => {
    setSearchParams((params) => {
      // Limpar parâmetros existentes
      params.delete('premio-por')
      params.delete('ranking-tipo')
      params.delete('order-by')
      params.delete('order-direction')
      params.delete('valor-minimo')
      params.delete('valor-maximo')
      params.delete('categoria')
      params.delete('disponivel')
      params.delete('posicao-minima')
      params.delete('posicao-maxima')

      // Aplicar filtros de categoria
      if (localFilters.categoria && localFilters.categoria !== 'todos') {
        params.set('categoria', localFilters.categoria)
      }

      // Aplicar filtros de valor
      if (localFilters.valorMinimo) {
        params.set('valor-minimo', localFilters.valorMinimo)
      }
      if (localFilters.valorMaximo) {
        params.set('valor-maximo', localFilters.valorMaximo)
      }

      // Aplicar filtros de ranking
      if (
        localFilters.rankingGeral ||
        localFilters.rankingCidade ||
        localFilters.rankingEscola ||
        localFilters.rankingTurma
      ) {
        params.set('premio-por', 'RANKING')

        // Determinar tipo de ranking baseado nos checkboxes marcados
        if (localFilters.rankingGeral) {
          params.set('ranking-tipo', 'geral')
        } else if (localFilters.rankingCidade) {
          params.set('ranking-tipo', 'cidade')
        } else if (localFilters.rankingEscola) {
          params.set('ranking-tipo', 'escola')
        } else if (localFilters.rankingTurma) {
          params.set('ranking-tipo', 'turma')
        }
      } else if (localFilters.naoVinculado) {
        params.set('premio-por', 'PONTOS')
      }

      // Aplicar filtros de posição
      if (localFilters.posicaoMinima) {
        params.set('posicao-minima', localFilters.posicaoMinima)
      }
      if (localFilters.posicaoMaxima) {
        params.set('posicao-maxima', localFilters.posicaoMaxima)
      }

      // Aplicar filtros de ordenação
      if (localFilters.orderBy) {
        params.set('order-by', localFilters.orderBy)
      }
      if (localFilters.orderDirection) {
        params.set('order-direction', localFilters.orderDirection)
      }

      return params
    })

    setCurrentPage(1) // Reset para primeira página
  }, [localFilters, setSearchParams])

  // Função para limpar todos os filtros
  const clearFilters = useCallback(() => {
    setLocalFilters({
      categoria: '',
      valorMinimo: '',
      valorMaximo: '',
      rankingGeral: false,
      rankingCidade: false,
      rankingEscola: false,
      rankingTurma: false,
      naoVinculado: false,
      posicaoMinima: '',
      posicaoMaxima: '',
      orderBy: 'nome',
      orderDirection: 'asc',
    })

    setSearchParams((params) => {
      params.delete('premio-por')
      params.delete('ranking-tipo')
      params.delete('order-by')
      params.delete('order-direction')
      params.delete('valor-minimo')
      params.delete('valor-maximo')
      params.delete('categoria')
      params.delete('disponivel')
      params.delete('posicao-minima')
      params.delete('posicao-maxima')
      return params
    })

    setCurrentPage(1)
  }, [setSearchParams])

  return {
    searchBarParams,
    setSearchParams,
    currentPage,
    setCurrentPage,
    localFilters,
    updateLocalFilter,
    applyFilters,
    clearFilters,
  }
}
